import type { IntlShape } from 'react-intl';

/** Localized hardcoded first assistant turn for the routine-creation chat. */
export function getRoutineCreateGuidedIntro(
  formatMessage: IntlShape['formatMessage']
): string {
  const question = formatMessage({
    defaultMessage: 'What kind of routine would you like to create?',
    id: 'wTbjzBppu+',
    description:
      'Hardcoded first assistant question opening the guided routine-creation chat, asking what kind of routine the user wants to create',
  });
  const explanation = formatMessage({
    defaultMessage:
      'A routine is something Heidi runs for you on a schedule or after an event — like summarising yesterday’s sessions each morning, sending a weekly digest of your team’s activity, or flagging notes still waiting to be signed.',
    id: '6wZS9vLUDI',
    description:
      'Hardcoded first assistant paragraph in the guided routine-creation chat, defining what a routine is and giving prose examples of routines',
  });
  const invitation = formatMessage({
    defaultMessage: 'Describe yours in your own words and I’ll set it up.',
    id: 'HS+Ya0sCFH',
    description:
      'Hardcoded first assistant closing line in the guided routine-creation chat, inviting the user to describe the routine they want',
  });
  return `${question}\n\n${explanation}\n\n${invitation}`;
}
